import jwtDecode from 'jwt-decode';

export default function tokenCheck() {
  const pbdToken = localStorage.getItem('pbdToken');

  if (pbdToken && pbdToken.length) {
    const decodedToken = jwtDecode(pbdToken);
    const currentDate = Math.floor(Date.now() / 1000);
    if (currentDate < decodedToken.exp) {
      return true;
    }
    localStorage.removeItem('pbdToken');
    localStorage.removeItem('userId');
  }
  return false;
}
